import { create } from 'zustand';

export const useSiteExportStore = create((set, get) => ({
  entities: {
    parcelEntities: [],
    topographyEntity: null,
    buildingEntity: null,
    projectedBuildingEntity:null,
  },
  
  setParcelEntities: (parcelEntity) =>
    set((state) => ({
      entities: { ...state.entities, parcelEntities: parcelEntity },
    })),

  // Topography methods
  setTopographyEntity: (topographyEntity) => 
    set((state) => ({
      entities: { ...state.entities, topographyEntity: topographyEntity },
    })),
   
  cleartopographyExport: () => 
    set((state) => ({
      entities: { ...state.entities, topographyEntity: null },
    })),
  
  // Building methods
  setBuildingEntity: (buildingEntity) => 
    set((state) => ({
      entities: { ...state.entities, buildingEntity: buildingEntity },
    })),
  
  clearbuildingExport: () => 
    set((state) => ({
      entities: { ...state.entities, buildingEntity: null },
    })),

    //Projected Building methods
  setProjectedBuildingEntity: (projectedBuildingEntity) => 
    set((state) => ({
      entities: { ...state.entities, projectedBuildingEntity: projectedBuildingEntity },
    })),
  
  clearProjectedbuildingExport: () => 
    set((state) => ({
      entities: { ...state.entities, projectedBuildingEntity: null },
    })),
  
  // Clear all entities at once
  clearAllEntities: () => 
    set({
      entities: {
        parcelEntities: [],
        topographyEntity: null,
        buildingEntity: null,
        projectedBuildingEntity:null,
      },
    }),
}));